var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggle-container"},_vm._l((_vm.ownVal),function(x){return _c('button',{staticClass:"btn m-1",class:x.active ? 'active' : '',on:{"click":function($event){return _vm.onClick(x)}}},[_vm._v(" "+_vm._s(x.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }